'use client';

// Formulaire de contact Ligobox (formulaire CRM app.ligobox.com/form/sales)
// intégré en bas de chaque article, EXACTEMENT comme le blog des tenants
// (components/eshop/PublicBlog.jsx › BlogFormIframe) : iframe auto-redimensionnée
// par le message postMessage `ligobox-form-resize` émis par la page du formulaire.
import { useEffect, useState } from 'react';

export default function ContactFormEmbed({ src }) {
  const [h, setH] = useState(560);
  useEffect(() => {
    const onMsg = (e) => {
      if (e && e.data && e.data.type === 'ligobox-form-resize' && e.data.height) {
        setH(Math.max(320, Math.ceil(e.data.height) + 16));
      }
    };
    window.addEventListener('message', onMsg);
    return () => window.removeEventListener('message', onMsg);
  }, []);
  if (!src) return null;
  // loading="lazy" : le formulaire embarque le captcha Turnstile (même raison que
  // côté tenant : ne pas le charger avant que le lecteur arrive en bas de page).
  return (
    <iframe title="Formulaire de contact" src={src} scrolling="no" loading="lazy"
      style={{ width: '100%', height: h, border: 'none', borderRadius: 12, background: 'transparent', display: 'block' }} />
  );
}
